import * as React from "react";

import { Link } from "react-router-dom";
import { Page, PageHero } from "src/components/common";

import OrganizationTabs from "./Tabs/OrganizationTabs";
import OrganizationAPI from "./API/OrganizationAPI";

interface IProps {
	location?: any;
	match?: any;
}

interface IState {
	organization: OrganizationDTO;
}

const defaultOgranization: OrganizationDTO = {
	name: "",
};

class OrganizationPage extends React.Component<IProps, IState> {
	public _isMounted = true;
	constructor(props: IProps) {
		super(props);
		this.state = {
			organization: defaultOgranization,
		};
	}

	public componentDidMount() {
		const { organizationId } = this.props.match.params;
		if (organizationId && Number(organizationId) > 0) {
			this.loadOrganization(organizationId);
		}
	}

	public componentWillUnmount() {
		this._isMounted = false;
	}

	public UNSAFE_componentWillReceiveProps(nextProps: {
		match: { params: { organizationId: any } };
	}) {
		const { organizationId } = nextProps.match.params;
		if (Number(organizationId) !== this.state.organization.id) {
			this.loadOrganization(organizationId);
		}
	}

	public render() {
		const { organization } = this.state;
		const organizationId = this.props.match.params.organizationId;
		const organizationName =
			(this.props.location.state && this.props.location.state.name) ||
			organization.name;
		const pageTitle = this.renderPageTitle(+organizationId, organizationName);

		return (
			<Page>
				<PageHero>
					<Link to="/admin/organizations">&lt; ORGANIZATIONS</Link>
					<h1 className="mb-0">{pageTitle}</h1>
				</PageHero>
				<OrganizationTabs
					className="mb-4"
					location={this.props.location}
					organizationId={organizationId}
				/>
				{this.props.children}
			</Page>
		);
	}

	private loadOrganization = (organizationId: number) => {
		OrganizationAPI.getOrganization({ id: organizationId }).then(
			(organization) => {
				if (this._isMounted) {
					this.setState({ organization });
				}
			}
		);
	};

	private renderPageTitle = (
		organizationId: number,
		organizationName: string
	) => {
		if (
			organizationId !== undefined &&
			Number(organizationId) > 0 &&
			organizationName !== undefined
		) {
			return `${organizationName} Details`;
		}

		if (
			organizationId !== undefined &&
			Number(organizationId) === 0 &&
			!organizationName
		) {
			return "Add organization";
		}

		return "ExceleRATE";
	};
}

export default OrganizationPage;
